import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteVehicle($id: ID!) {
        deleteVehicle(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
